const lonLatRegexp = (() => {
  const number = `[-−]?\\s*\\d+([.,]\\d+)?`;
  const getCoordinate = (n) => `((?<hemispherePrefix${n}>[NWSE]))?((?<degrees${n}>${number})(\\s*[°]\\s*|\\s*deg\\s*|\\s+|$|(?!\\d)))((?<minutes${n}>${number})(\\s*['′’]\\s*))?((?<seconds${n}>${number})(\\s*["″”]\\s*))?((?<hemisphereSuffix${n}>[NWSE]))?`;
  const coords = `(geo\\s*:\\s*)?\\s*` + getCoordinate(1) + `(?<separator>\\s*[,;]\\s*|\\s+)` + getCoordinate(2) + `(\\?z=(?<zoom>\\d+))?`;
  return new RegExp(`^\\s*${coords}\\s*$`, "i");
})();
function parseGpsCoordinates(input) {
  const m = lonLatRegexp.exec(input);
  const prepareNumber = (str) => Number(str.replace(",", ".").replace("−", "-").replace(/\s+/, ""));
  const prepareCoords = (deg, min, sec, hem) => {
    const degrees = prepareNumber(deg);
    const result = Math.abs(degrees) + (min ? prepareNumber(min) / 60 : 0) + (sec ? prepareNumber(sec) / 3600 : 0);
    return result * (degrees < 0 ? -1 : 1) * (hem && ["s", "S", "w", "W"].includes(hem) ? -1 : 1);
  };
  if (m) {
    const { hemispherePrefix1, degrees1, minutes1, seconds1, hemisphereSuffix1, separator, hemispherePrefix2, degrees2, minutes2, seconds2, hemisphereSuffix2, zoom } = m.groups;
    let hemisphere1 = void 0, hemisphere2 = void 0;
    if (hemispherePrefix1 && !hemisphereSuffix1 && hemispherePrefix2 && !hemisphereSuffix2) {
      [hemisphere1, hemisphere2] = [hemispherePrefix1, hemispherePrefix2];
    } else if (!hemispherePrefix1 && hemisphereSuffix1 && !hemispherePrefix2 && hemisphereSuffix2) {
      [hemisphere1, hemisphere2] = [hemisphereSuffix1, hemisphereSuffix2];
    } else if (hemispherePrefix1 && hemisphereSuffix1 && !hemispherePrefix2 && !hemisphereSuffix2 && !separator.trim()) {
      [hemisphere1, hemisphere2] = [hemispherePrefix1, hemisphereSuffix1];
    } else if (hemispherePrefix1 || hemisphereSuffix1 || hemispherePrefix2 || hemisphereSuffix2) {
      return void 0;
    }
    const coordinate1 = prepareCoords(degrees1, minutes1, seconds1, hemisphere1);
    const coordinate2 = prepareCoords(degrees2, minutes2, seconds2, hemisphere2);
    const zoomNumber = zoom ? Number(zoom) : void 0;
    const zoomObj = zoomNumber != null && isFinite(zoomNumber) ? { zoom: zoomNumber } : {};
    if ([void 0, "n", "N", "s", "S"].includes(hemisphere1) && [void 0, "w", "W", "e", "E"].includes(hemisphere2)) {
      return { lat: coordinate1, lon: coordinate2, ...zoomObj };
    } else if (["w", "W", "e", "E"].includes(hemisphere1) && [void 0, "n", "N", "s", "S"].includes(hemisphere2)) {
      return { lat: coordinate2, lon: coordinate1, ...zoomObj };
    }
  }
}
export {
  parseGpsCoordinates
};
//# sourceMappingURL=parse-gps-coordinates.js.map
